export default __webpack_public_path__ + "static/media/white.d6647f08.svg";